import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Header, Segment, Table, Icon, Menu } from 'semantic-ui-react';
import EstimateOtherCostsTableRow from './EstimateOtherCostsTableRow';
import EstimateMaterialTable from './EstimateMaterialTable';
import EstimateLabourTable from './EstimateLabourTable';
import EstimateForm from './EstimateForm';

class Estimate extends Component {
  state = {
    isEstimateFormOpen: false
  }
  // openMarginForm = () => this.setState({ isMarginFormOpen: true })
  // closeMarginForm = () => this.setState({ isMarginFormOpen: false })
  // setMargin = event => {
  //   const parsedInt = parseInt(event.target.value, 10)
  //   if (!isNaN(parsedInt)) {
  //     const multiplier = (parsedInt / 100) + 1
  //     this.props.estimate.setMultiplier(multiplier)
  //   }
  // }
  toggleEstimateForm = () => this.setState({ isEstimateFormOpen: !this.state.isEstimateFormOpen })
  render() { 
    const { estimate } = this.props
    const { isEstimateFormOpen } = this.state
    if (!estimate) return null
    return (
      <Segment>
        <Header as='h3'>
          {estimate.qty}x
          &emsp;
          <small>
            ${estimate.sumMaterials().toFixed(2)}&nbsp;
            + ${estimate.sumLabourDollars().toFixed(2)}&nbsp;
            + ${estimate.sumAdditionalCosts().toFixed(2)}&nbsp;
            <span style={{ color: estimate.multiplier !== 1 ? 'red' : 'gray' }}>+ ${estimate.calculateMarginCost().toFixed(2)} ({estimate.multiplierAsPercentage}%)</span>&nbsp;
            = <em>${estimate.sumAllWithMargin().toFixed(2)} total</em>&nbsp;
            or <em>${estimate.costPerUnit().toFixed(2)} each</em>
          </small>
        </Header>
        <Menu text>
          <Menu.Item>
            <a href='#recalculate-all' onClick={estimate.recalculateAll}><Icon name='refresh' /> Re-calculate all</a>
          </Menu.Item>
          <Menu.Item>
            <a href='#edit-margin' onClick={this.toggleEstimateForm}>
              {isEstimateFormOpen
                ? <span><Icon name='check' /> Done</span>
                : <span><Icon name='percent' /> Edit margin or hourly rate</span>
              }
            </a>
          </Menu.Item>
        </Menu>
        {isEstimateFormOpen &&
          <EstimateForm estimate={estimate} readOnlyQty />
          // <Form>
          //   <Form.Group>
          //     <Form.Field>
          //       <Input
          //         type='number'
          //         width={4}
          //         value={estimate.multiplierAsPercentage}
          //         onChange={this.setMargin}
          //         label='%'
          //       />
          //     </Form.Field>
          //     <Form.Button
          //       type='button' basic color='green'
          //       content='OK'
          //       onClick={this.closeMarginForm}
          //     />
          //   </Form.Group>
          // </Form>
        }
        <EstimateMaterialTable estimate={estimate} />
        <EstimateLabourTable estimate={estimate} />
        <Table striped compact='very'>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Other Costs</Table.HeaderCell>
              <Table.HeaderCell>Cost</Table.HeaderCell>
              <Table.HeaderCell />
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {estimate.additionalCosts.map((item, index) => (
              <EstimateOtherCostsTableRow key={index} item={item} />
            ))}
          </Table.Body>
          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell>
                <a href='#recalculate-additional-costs' onClick={estimate.recalculateAdditionalCosts}>
                  <Icon name='refresh' /> Re-calculate
                </a>
              </Table.HeaderCell>
              <Table.HeaderCell><strong>${estimate.sumAdditionalCosts()}</strong></Table.HeaderCell>
              <Table.HeaderCell />
            </Table.Row>
          </Table.Footer>
        </Table>
      </Segment>
    )
  }
}
 
export default observer(Estimate);


// WEBPACK FOOTER //
// ./src/components/jobs/EstimateView.js